/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import "./PaySlipModal.css";
import PaySlipContent from "./PaySlipContent/PaySlipContent";

import PayslipCustomModal from "../../PayslipCustomModal/PayslipCustomModal";

interface ModalProps {
  isModalOpen?: boolean;
  closeModal?: any;
  allowances?: any;
  otherBenefits?: any;
  employeeName: string;
  employeeDesignation: string;
  employeeId: number;
  payslipData?: any;
  staffId: number;
  currency: string;
}

const PaySlipModalPresenter = ({
  isModalOpen,
  closeModal,
  employeeDesignation,
  currency,
  employeeName,
  staffId,
  payslipData,
}: ModalProps) => {
  return (
    <PayslipCustomModal isModalOpen={isModalOpen}>
      <PaySlipContent
        currency={currency}
        employeeDesignation={employeeDesignation}
        employeeName={employeeName}
        staffId={staffId}
        payslipData={payslipData}
        closeModal={closeModal}
      />
    </PayslipCustomModal>
  );
};

export default PaySlipModalPresenter;
